import { combineReducers } from "redux";

import {
    emailSchedulerOverviewNewRuleReducer,
    EmailSchedulerRuleDefinitionState,
} from "store/features/emailScheduler/definition";
import {
    EmailSchedulerExceptionsInitialState,
    emailSchedulerExceptionsReducer,
} from "store/features/emailScheduler/exceptions";
import { emailSchedulerOverviewReducer, EmailSchedulerOverviewState } from "store/features/emailScheduler/overview";

export type EmailSchedulerState = Readonly<{
    overview: EmailSchedulerOverviewState;
    definition: EmailSchedulerRuleDefinitionState;
    exceptions: EmailSchedulerExceptionsInitialState;
}>;

export const emailSchedulerReducers = combineReducers<EmailSchedulerState>({
    overview: emailSchedulerOverviewReducer,
    definition: emailSchedulerOverviewNewRuleReducer,
    exceptions: emailSchedulerExceptionsReducer,
});
